var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-speed-dial',_vm._b({staticClass:"c-speed-dial",attrs:{"value":_vm.internalValue},on:{"input":_vm.input},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_vm._t("activator",null,{"bind":_vm.bind})]},proxy:true}],null,true)},'v-speed-dial',_vm.$attrs,false),[_vm._t("default",null,{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }